import styled from "styled-components";

export const SectionItemContainer = styled.div`
  color: rgb(73, 73, 73);
  position: relative;
  opacity: ${({ disabled }) => (disabled ? 0.7 : 1)};
  pointer-events: ${({ disabled }) => (disabled ? "none" : "auto")};
`;

export const SectionItem = styled.div`
  min-height: 33px;
  box-sizing: border-box;

  position: sticky;
  top: -8px;
  z-index: 1;

  display: flex;
  align-items: center;
  gap: 8px;

  box-sizing: border-box;
  cursor: pointer;
  color: rgb(73, 73, 73);
  font-size: 18px;
  white-space: nowrap;
  font-size: 12px;

  border-radius: 8px;
  background-color: ${({ selected }) => (selected ? "#f4f4f4" : "")};

  &:hover {
    background-color: #f4f4f4;
  }

  padding: 0px;

  svg {
    width: 16px;
    height: 16px;
    min-width: 16px;
  }
  span {
    line-height: normal;
  }
`;

export const SectionInnerContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding-left: 2px;
  margin-left: 15px;
  position: relative;

  /* Animation styles */
  padding-top: 2px;
  max-height: 1000px; /* Should be large enough for your content */
  opacity: 1;
  transition: max-height 0.3s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s;

  &.collapsed {
    padding-top: 0px;
    max-height: 0;
    opacity: 0;
    overflow: hidden;
    transition: max-height 0s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.2s;
  }

  :before {
    content: "";
    position: absolute;
    left: -1px;
    top: 0px;
    width: 1px;
    /* height: calc(100% - 14px); */
    background-color: rgb(209 209 209);
    height: 100%;
  }
`;

export const StyledSectionIcon = styled.div`
  padding: 4px;
  background: rgba(0, 0, 0, 0.04);
  border-radius: 8px;
  width: 33px;
  height: 33px;
  min-width: 33px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SectionInnerContainerItem = styled.div`
  display: flex;
  height: 28px;
  align-items: center;
  padding: 0px 4px;
  border-radius: 6px;
  margin-left: 0px;
  gap: 4px;
  /* border: 1px solid #eee; */
  /* border-radius: 100px; */
  position: relative;

  :before {
    content: "";
    position: absolute;
    left: -5px;
    top: 50%;
    transform: translateY(-50%);
    width: 5px;
    height: 1px;
    background-color: rgb(209 209 209);
    display: none;
  }

  span {
    font-size: 12px;
    line-height: 20px;
    white-space: nowrap; /* Prevent text from wrapping to the next line */
    overflow: hidden; /* Hide the overflowing text */
    text-overflow: ellipsis; /* Add ellipsis (...) to indicate overflow */
  }
  cursor: pointer;

  .layer-icons {
    display: none !important;

    svg {
      width: 14px;
      height: 14px;
    }
  }

  background-color: ${({ selected }) => (selected ? "#f4f4f4" : "")};

  :hover {
    background-color: #f4f4f4;

    .layer-icons {
      display: flex !important;
    }
  }
`;
